import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '@/lib/api';

/**
 * Privacy-first, cookieless page-view tracker. Fires a fire-and-forget POST to
 * /api/track on every route change. The backend derives a daily-rotating,
 * non-reversible visitor hash from IP+UA (never stored) and attributes the view
 * to the logged-in user when an auth token is present. No cookies, no PII.
 */
export const PageTracker = () => {
  const location = useLocation();
  const last = useRef(null);
  useEffect(() => {
    const path = location.pathname;
    if (last.current === path) return; // de-dupe rapid re-renders
    last.current = path;
    api.post('/track', { path, referrer: document.referrer || null }).catch(() => {});
  }, [location.pathname]);
  return null;
};
